/**
 * NoteReferenceView — React NodeView for the NoteReference inline node.
 *
 * Renders a note icon + title as a clickable inline chip that opens the
 * entity preview modal (see EntityPreviewContext) rather than navigating away.
 */

import { NodeViewWrapper, type NodeViewProps } from '@tiptap/react';
import { useEntityPreview } from '../../contexts/EntityPreviewContext';

export function NoteReferenceView({ node }: NodeViewProps) {
  const { id, title } = node.attrs;
  const { openPreview } = useEntityPreview();

  function handleClick(e: React.MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
    if (id) {
      openPreview('note', id);
    }
  }

  return (
    <NodeViewWrapper as="span" className="note-reference-node">
      <button
        type="button"
        className="note-reference-link"
        onClick={handleClick}
        contentEditable={false}
        aria-label={`Open note: ${title || 'Untitled note'}`}
      >
        <span className="note-reference-icon">📝</span>
        <span className="note-reference-title">{title || 'Untitled note'}</span>
      </button>
    </NodeViewWrapper>
  );
}
